import { render, staticRenderFns } from "./baseAddTag.vue?vue&type=template&id=c352e148&scoped=true"
import script from "./baseAddTag.vue?vue&type=script&lang=js"
export * from "./baseAddTag.vue?vue&type=script&lang=js"
import style0 from "./baseAddTag.vue?vue&type=style&index=0&id=c352e148&prod&lang=scss"
import style1 from "./baseAddTag.vue?vue&type=style&index=1&id=c352e148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c352e148",
  null
  
)

export default component.exports